<template>
  <RegistrationContent/>
</template>

<script>
import RegistrationContent from "@/components/Authentication/RegistrationContent/RegistrationContent";

export default {
  name: "RegistrationPage",
  components: {RegistrationContent}
};
</script>

<style scoped>

</style>